import request from "@/utils/request";
// 手动上传
export function manualUploadData(params, onUploadProgress) {
  return request({
    url: "/remedialStrategy/manualUploadData",
    method: "post",
    data: params,
    onUploadProgress,
  });
}
// 
export function queryManualUploadList(params) {
  return request({
    url: "/remedialStrategy/queryManualUploadList",
    method: "get",
    params: params,
  });
}
export function reloadManualUploadReq(params) {
  return request({
    url: "/remedialStrategy/reloadManualUpload",
    method: "post",
    data: params,
  });
}
